/** @jsx jsx */
import { jsx } from "theme-ui"
import { useTranslation } from "react-i18next"
import { keyframes } from "@emotion/core"
import { useEffect, useState } from "react"

import Button from "../Button"

import finger from "../../../images/icons/finger.svg"

const miceKeyframe = keyframes`
  0% {
    transform: scaleY(0)
  }
  100% {
    transform: scaleY(1)
  }
`

const LandingButton = ({ data, fadeInDelay }) => {
  const { i18n } = useTranslation()
  const [isVisible, setVisible] = useState(false)

  useEffect(() => {
    let visibilityTimeout = null

    const updateButtonVisibility = () => {
      visibilityTimeout = setTimeout(() => {
        setVisible(true)
      }, fadeInDelay * 1000 - 500)
    }

    window.addEventListener("landingTitleAnimationEnd", updateButtonVisibility)

    return () => {
      window.removeEventListener(
        "landingTitleAnimationEnd",
        updateButtonVisibility
      )
      clearTimeout(visibilityTimeout)
    }
  }, [fadeInDelay])

  const onClick = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: "smooth",
    })
  }

  return (
    <div
      sx={{
        pb: 5,
        transition: "all 0.5s",
        opacity: isVisible ? 1 : 0,
        visibility: isVisible ? "visible" : "hidden",
      }}
    >
      <Button variant="big" onClick={onClick}>
        <img
          sx={{ display: ["block", "none"], mr: "15px", width: "26px" }}
          src={finger}
          alt="tap to find out"
        />
        <div
          sx={{
            display: ["none", "block"],
            position: "relative",
            width: "18px",
            height: "28px",
            border: "1px solid #1739E6",
            borderRadius: "10px",
            [`${i18n.dir() === "rtl" ? "ml" : "mr"}`]: "15px",
          }}
        >
          <div
            sx={{
              position: "absolute",
              top: "7px",
              left: "50%",
              width: "1px",
              height: "5px",
              background: "#1739E6",
              animation: `${miceKeyframe} 0.666s alternate infinite ease-in-out`,
              transformOrigin: "bottom center",
            }}
          />
        </div>
        <span sx={{ display: ["none", "inline"] }}>{data.scrollHint}</span>
        <span sx={{ display: ["inline", "none"] }}>{data.tapHint}</span>
      </Button>
    </div>
  )
}

export default LandingButton
